/**
 * @fileoverview The name of the window event the API client fires when something needs a subscription (a paused
 * plan's write, Free's plants all growing, or the photo AI) and the subscription wall listens for. One home for the
 * name, imported directly by both ends (C118 review: it was a value-file read and a re-export through the billing
 * API file, which put the wall on the value-file allow-list).
 *
 * Where: shared/api/apiClient (fires it), features/billing/components/SubscriptionWall (listens).
 * API: none.
 *
 * @module subscriptionEvent
 */

/**
 * The window event the API client fires when something needs a subscription (billing; apiClient fires it,
 * SubscriptionWall listens).
 * @kept K1
 */
export const SUBSCRIPTION_REQUIRED_EVENT = 'grow:subscription-required';
